const SET_STORE_PROP = 'SET_STORE_PROP'
const SET_LOADED_STORE_PROP = 'SET_LOADED_STORE_PROP'

import CloneDeep from 'lodash/cloneDeep'

export default {
  namespaced: true,
  state: {
    godMode: false,
    cacheKey: 'cache_props',
    allDbStore: {}, // всі налаштування по користувачу
    loadedAllDbStore: false, // Все настрйоки загружены
    storageError: false, // ознака помилки передачі даних
  },
  getters: {
    cacheKey: (state) => state.cacheKey,
    godMode: (state) => state.godMode ?? false,
    allDbStore: (state) => state.allDbStore,
    loadedAllDbStore: (state) => state.loadedAllDbStore,
    storageError: (state) => localStorage.getItem(`${state.cacheKey}_error` ?? state.storageError)
  },
  mutations: {
    [SET_STORE_PROP](state, item) {
      state.allDbStore[item.key] = item.value
    },
    [SET_LOADED_STORE_PROP](state) {
      state.loadedAllDbStore = true
    },
    
  },
  actions: {
    setSorageError({ state }, value) {
      state.storageError = value
      localStorage.setItem(`${state.cacheKey}_error`, value)
    },
    setStoreProp({ commit }, { key, value }) {
      commit(SET_STORE_PROP, { key: '' + key, value: CloneDeep(value) })
    },
    setLoadedStoreProp({ commit }) {
      commit(SET_LOADED_STORE_PROP)
    },
    deleteStoreProp({ state }, { key }) {
      delete state.allDbStore[key]
    },
  }
}
